(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-scrolling-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-scrolling-collections-more]');
    if (!button) return;

    var container = button.closest('.scrolling-collections');
    if (!container) return;

    var hiddenTiles = container.querySelectorAll('.scrolling-collections__tile--hidden');
    var batchSize = parseInt(button.dataset.batchSize, 10) || hiddenTiles.length;

    for (var i = 0; i < batchSize && i < hiddenTiles.length; i++) {
      hiddenTiles[i].classList.remove('scrolling-collections__tile--hidden');
    }

    if (container.querySelectorAll('.scrolling-collections__tile--hidden').length === 0) {
      button.style.display = 'none';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
